//import { StylesProvider } from '@material-ui/core'
import React, { Component } from 'react';
import styles from './DragNDrop.module.css';

class DragAndDrop extends Component {
    state = {
        drag: false,
        dragCounter:0
    }  
    dropRef = React.createRef()  
    clickRef = React.createRef()  
    
    handleClick = (e) => {
        // If multiple is true, we need to create a new input element to handle multiple files
        if (this.props.multiple) {
            const input = document.createElement('input');
            input.type = 'file';
            input.multiple = true;
            input.accept = 'image/*';
            input.onchange = (e) => {
                if (e.target.files && e.target.files.length > 0) {
                    // Limit to 10 files
                    const files = Array.from(e.target.files).slice(0, 10);
                    this.props.handleDrop(files);
                }
            };
            input.click();
        } else {
            this.props.handleFileSelect(e);
        }
    };

    handleEdit = (e) => {
      // console.log("Click");
        this.props.edit(e);
    };

    handleDrag = (e) => {
        // console.log("Drag");
        e.preventDefault();
        e.stopPropagation();
    };

    handleDragIn = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState(prevState => ({
            dragCounter: prevState.dragCounter + 1,
            drag: true
        }));
    };

    handleDragOut = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState(prevState => ({
            dragCounter: prevState.dragCounter - 1
        }), () => {
            if (this.state.dragCounter === 0) {
                this.setState({ drag: false }, () => {
                });
            }
        });
    };

    handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ drag: false, dragCounter: 0 });
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            const files = Array.from(e.dataTransfer.files);
            this.props.handleDrop(files, this.props.index);
        }
    };

    componentDidMount() {
        let div = this.dropRef.current;
        div.addEventListener('dragenter', this.handleDragIn);
        div.addEventListener('dragleave', this.handleDragOut);
        div.addEventListener('dragover', this.handleDrag);
        div.addEventListener('drop', this.handleDrop);
    }

    componentWillUnmount() {
        let div = this.dropRef.current;
        let click = this.clickRef.current;
        div.removeEventListener('dragenter', this.handleDragIn);
        div.removeEventListener('dragleave', this.handleDragOut);
        div.removeEventListener('dragover', this.handleDrag);
        div.removeEventListener('drop', this.handleDrop);
        click.removeEventListener('click', this.handleClick);
    }

    render() {
        return (
            <div
                style={{ position: 'relative' }}
                ref={this.dropRef}
            >
                <div 
                    className={`upload-wrapper ${this.props.file.name !== undefined ? styles.dropped : 'text-center'}`}
                    onClick={this.handleClick}
                >
                    <svg ref={this.clickRef} style={{ cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className={`bi bi-upload ${this.props.file.name !== undefined ? styles.hidden : ''}`} viewBox="0 0 16 16" strokeWidth="1" stroke="#494949">
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                        <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                    </svg>
                    {
                        this.props.file.name === undefined
                            ?
                            (<span>{
                                this.props.copy !== undefined
                                    ? this.props.copy
                                    : 'Drag & Drop'
                            }</span>)
                            :
                            (
                                <span className={`d-flex`}>
                                    <a href={this.props.file.url} target="_blank" draggable="false">
                                        {this.props.file.name}
                                    </a>
                                    {this.props.edit &&
                                        <button className={`align-items-center d-flex justify-content-center p-0 position-absolute ${styles.btnEditXls}`} onClick={() => this.props.edit()}>
                                            <svg className={`m-0 position-static`} width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5.10463 1.60662L7.10489 3.60688L2.76141 7.95036L0.97802 8.14723C0.739276 8.17364 0.537563 7.97177 0.564125 7.73302L0.762557 5.94838L5.10463 1.60662V1.60662ZM8.34205 1.30882L7.40285 0.369623C7.10989 0.0766621 6.63475 0.0766621 6.34179 0.369623L5.45822 1.25319L7.45848 3.25345L8.34205 2.36988C8.63501 2.07677 8.63501 1.60178 8.34205 1.30882V1.30882Z" fill="#ffffff" />
                                            </svg>
                                        </button>
                                    }
                                    <div className={styles.removeBtn} onClick={() => this.props.removeFiles(this.props.type, this.props.index)}>
                                        <div className={styles.inner1}>
                                            <div className={styles.inner2}></div>
                                        </div>
                                    </div>
                                </span>
                            )
                    }
                </div>

                {this.state.drag &&
                    <div 
                        style={{
                            border: 'dashed #24ABFF 2px',
                            backgroundColor: 'rgba(255,255,255,.8)',
                            position: 'absolute',
                            top: 0,
                            bottom: 0,
                            left: 0, 
                            right: 0,
                            zIndex: 9999
                        }}
                    >
                        <div 
                            style={{
                                position: 'absolute',
                                top: '50%',
                                right: 0,
                                left: 0,
                                textAlign: 'center',
                                color: 'grey',
                                fontSize: 36
                            }}
                        >
                        </div>
                    </div>
                }
                {this.props.children}
            </div>
        );
    }
}

export default DragAndDrop